import React from 'react';
import { Modal } from 'react-bootstrap';
import Add_Dmvic_Underwritter from '../forms/setup/Add_Dmvic_Underwritter';

function AddDmvic(props) {
    return (
   <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add DMVIC</h5> 
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Add_Dmvic_Underwritter {...props} />
        </Modal.Body>
      </Modal>
    </div>
    );
}

export default AddDmvic;